const DEFAULT_MEDIA_STORAGE_ENDPOINT = 'https://storage.yandexcloud.net'

const stripSearchAndHash = (url: URL) => {
  url.search = ''
  url.hash = ''
  return url.toString()
}

export const toBrowserMediaUrl = (
  value: string | null | undefined,
  mediaStorageEndpoint = DEFAULT_MEDIA_STORAGE_ENDPOINT
): string | null => {
  if (!value) {
    return null
  }

  const trimmed = value.trim()
  if (trimmed.length === 0) {
    return null
  }

  const normalizedEndpoint = mediaStorageEndpoint.trim().replace(/\/+$/, '')
  const normalizedValue = trimmed.startsWith('//') ? `https:${trimmed}` : trimmed

  if (normalizedValue.toLowerCase().startsWith('s3://')) {
    const withoutScheme = normalizedValue.slice('s3://'.length)
    const slashIndex = withoutScheme.indexOf('/')
    if (slashIndex <= 0) {
      return normalizedValue
    }

    const bucket = withoutScheme.slice(0, slashIndex)
    const key = withoutScheme.slice(slashIndex + 1).replace(/^\/+/, '')
    if (!bucket || !key) {
      return normalizedValue
    }

    return `${normalizedEndpoint}/${encodeURIComponent(bucket)}/${key
      .split('/')
      .map((segment) => encodeURIComponent(segment))
      .join('/')}`
  }

  try {
    const parsed = new URL(normalizedValue)
    const hasAwsSignedQuery = [...parsed.searchParams.keys()].some((key) =>
      key.toLowerCase().startsWith('x-amz-')
    )

    if (parsed.hostname === 'object-storage.yandexcloud.net') {
      parsed.protocol = 'https:'
      parsed.hostname = 'storage.yandexcloud.net'
      return stripSearchAndHash(parsed)
    }

    if (hasAwsSignedQuery) {
      return stripSearchAndHash(parsed)
    }

    return parsed.toString()
  } catch {
    return normalizedValue
  }
}
